var _defs, _clipPath, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 500,
    width: 500,
    x: 0,
    y: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29144 250C8.29144 115.226 117.547 5.9706 252.321 5.9706C387.095 5.9706 496.35 115.226 496.35 250C496.35 384.774 387.095 494.029 252.321 494.029C117.547 494.029 8.29144 384.774 8.29144 250Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#aa7d50",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.755 120.044L191.755 192.587C202.924 186.59 213.623 180.594 223.735 174.716C234.081 168.602 244.427 162.605 254.656 156.844C266.179 163.076 277.466 169.307 288.753 175.539C300.04 181.77 311.327 188.236 322.849 195.056L344.835 208.224L344.835 311.571C341.073 313.922 337.31 316.156 333.666 318.155C329.903 320.154 326.141 322.388 322.026 324.739C310.856 330.97 299.922 337.319 288.517 343.786C277.348 350.253 266.179 356.837 255.009 363.538C239.96 354.72 224.91 346.137 209.978 337.437C195.047 328.854 179.997 320.154 164.948 311.336L164.948 205.049C164.948 188.119 165.065 171.071 165.065 154.14C165.183 137.21 165.183 120.867 164.948 105.465L164.948 104.877C174.824 109.815 183.76 114.753 191.755 120.044ZM255.479 186.708C244.78 192.704 234.081 198.7 223.617 204.814C213.153 211.046 202.454 217.277 191.755 223.391L191.755 295.934C202.454 302.165 213.153 308.396 223.617 314.275C234.081 320.271 244.545 326.385 254.892 332.617C265.591 326.62 276.29 320.624 286.754 314.51C297.218 308.396 307.917 302.047 318.616 295.934L318.616 223.391C307.917 217.16 297.453 211.163 287.107 205.049C276.643 198.936 266.179 192.822 255.479 186.708Z",
    fill: "#aa7d50",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBased);
export default __webpack_public_path__ + "static/media/based.fe7e422cdb441ba875985dfab6641604.svg";
export { ForwardRef as ReactComponent };